import React, { Component } from 'react'
import { Product } from "../components";

export class ProductPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bc : false,
        };
    }

    componentDidMount() {
        this.setBreadcrumb()
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.update===true){
            
        }

        this.setBreadcrumb()
    }

    setBreadcrumb(){
        const { main } = this.props
        const { bc } = this.state
        const { setBreadcrumb } = this.props

        if(bc===false){
            var title = (main.language)? main.language.MENU_PRODUCT : "-"
            setBreadcrumb(title, [{name:title, link:"/product"}])
            this.setState({ bc:true })
        }
    }

    render() {
        return (
            <main>
                <div role="main" className="main">
                    <Product {...this.props} />
                </div>
            </main>
        )
    }
}

export default ProductPage
